var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.133 24V13.067h3.733L12.4 8.8H8.133V6.133c0-1.2.4-2.133 2.133-2.133h2.267V.133C12 .133 10.667 0 9.2 0 6 0 3.733 2 3.733 5.6v3.2H0v4.267h3.733V24z","fill":"#fff","fillRule":"evenodd"}));
}

Fb.defaultProps = {"width":"12.533","height":"24"};

module.exports = Fb;

Fb.default = Fb;
